import { Chalet, Amenity, ExtraOption } from '../types';

export const AMENITIES: Amenity[] = [
  { id: 'wifi', label: 'Wifi', icon: 'Wifi' },
  { id: 'sauna', label: 'Sauna', icon: 'ThermometerSun' },
  { id: 'pets', label: 'Huisdieren toegestaan', icon: 'Dog' },
  { id: 'hiking', label: 'Wandelroutes', icon: 'Map' },
  { id: 'kitchen', label: 'Keuken', icon: 'Utensils' },
  { id: 'parking', label: 'Gratis parkeren', icon: 'Car' },
  { id: 'BBQ', label: 'BBQ', icon: 'Beef' },
  { id: 'TV', label: 'TV', icon: 'Tv' },
  { id: 'jacuzzi', label: 'Hottub', icon: 'Bath' },
  { id: 'garden', label: 'Grote tuin', icon: 'Flower' },
  { id: 'kidsteam', label: 'Animatieteam', icon: 'Cat' },
  { id: 'cycle', label: 'Fietsroutes', icon: 'Bike' },
  { id: 'gym', label: 'Gym', icon: 'Dumbbell' },
  { id: 'fireplace', label: 'Houtkachel', icon: 'Flame' },
  { id: 'roof', label: 'Overkapping', icon: 'Warehouse' },
  { id: 'woods', label: 'Bosrijke omgeving', icon: 'TreePine' },  
  { id: 'cycle2', label: 'Fietsen', icon: 'Bike' },
  { id: 'bed', label: 'Bedstee', icon: 'Bed' },
  { id: 'terrace', label: 'Terras', icon: 'House' },
  { id: 'beach', label: 'Strand', icon: 'Volleyball' },
  { id: 'airconditioning', label: 'Airconditioning', icon: 'AirVent' },
  { id: 'boat', label: 'Bootverhuur', icon: 'Sailboat' },
  { id: 'vent', label: 'Ventilator', icon: 'AirVent' },
  { id: 'restaurant', label: 'Restaurant', icon: 'Utensils' },
  { id: 'heating', label: 'Verwarming', icon: 'Heater' },
  { id: 'watersport', label: 'Watersportactiviteiten', icon: 'Kayak' },
  { id: 'pool', label: 'Zwembad', icon: 'WavesLadder' },
  { id: 'wash', label: 'Wasserette', icon: 'WashingMachine' },
  { id: 'tennis', label: 'Tennisbaan', icon: 'CircleStar' },
  { id: 'wintersport', label: 'Wintersport', icon: 'CableCar' },
  { id: 'mountain', label: 'Bergen', icon: 'MountainSnow' },
];

export const INITIAL_EXTRAS: ExtraOption[] = [
  { id: 'breakfast', label: 'Luxe Ontbijt (elke dag)', price: 15 },
  { id: 'linens', label: 'Extra Linnengoed', price: 10 },
  { id: 'bike', label: 'Huurfietsen (2 stuks)', price: 25 },
];